import handlebars from "handlebars";
import { GetAppraisalModel } from "../../../../../all_Interfaces";
import currencySymbolMap from "currency-symbol-map";
import cmAppraisalValuesTemplate from "../templates/cmAppraisalValuesTemplate";
import equityAssetTemplate from "../templates/equityAssetTemplate";
import headerTemplate from "../templates/headerTemplate";

export const compileHeaderTemplate = (
    appraisalData:GetAppraisalModel
  ): string => {
    const compiledHeaderTemplate = handlebars.compile(headerTemplate);


    const data = {
        investmentId: appraisalData.investmentId,
        investmentName:appraisalData.investmentName,
        appraisalType : appraisalData.appraisalType
    }

    console.log(data);

    return compiledHeaderTemplate(data);
}